import { uiStrings } from '../../../actions/ui_strings';
import { localStorageLang, PASSORD_MAX_CHARACTERS, POST_CODE_REGEX, EMAIL_REGEX } from '../../../constants';
import { isFuture, isValidDate } from '../../../form_helpers'

const validate = values => {
  const language = localStorage.getItem(localStorageLang) === null ? 0 : parseInt(localStorage.getItem(localStorageLang), 10);
  const strings = uiStrings[language];

  const errors = {}
  /* Page One */
  if(!values.person_name) {
    errors.person_name = strings.required;
  }
  if (!values.email) {
      errors.email = strings.required;
  } else if (!EMAIL_REGEX.test(values.email)) {
      errors.email = strings.invalidEmail;
  }
  if(!values.password) {
      errors.password = strings.required;
  } else if (values.password.length < 6) {
      errors.password = strings["00010"];
  } else if(values.password.length > PASSORD_MAX_CHARACTERS) {
      errors.password = strings["00034"];
  }
  if(!values.email_confirm) {
    errors.email_confirm = strings.required;
  } else if(values.email_confirm !== values.email) {
    errors.email_confirm = strings.emailDontMatch;
  }
  /* Page Two */
  if (!values.terms_accepted) {
      errors.terms_accepted = strings.required;
  }
  if (!POST_CODE_REGEX.test(values.postcode) ) {
    errors.postcode = strings.invalidPostCode;
  }

  // check date parts
  const day = (values.day === undefined || values.day === "") ? false : true;
  const month = (values.month === undefined || values.month === "") ? false : true;
  const year = (values.year === undefined || values.year === "") ? false : true;


  if (day || month || year) {
    // user has entered at least part of a date
    // is it a valid date?
    // check all parts are entered, if not, error on missing
    if (!day || !month || !year) {
      // all date parts need to be entered, throw error
      errors.dateError = strings["00025"];
    } else {
      // check it's a valid date
      if(!isValidDate(values.day, values.month, values.year)) {
        errors.dateError = strings["00025"];
      } else {
        // is it in the past?
        if(isFuture(`${values.year}-${values.month}-${values.day}`)) {
          errors.dateError = strings.choosePast;
        }
        // is it too old?
        if(values.year < 1880) {
          errors.dateError = strings["00025"];
        }
      }
    }
  }

  return errors;
}

export default validate
